<template>
  <div class="auth-page">
    <div class="auth-left">
      <div class="auth-brand">
        <img src="/logo.svg" alt="ubuHle" class="auth-brand-logo" />
      </div>
      <h1 class="auth-tagline">Your salon<br /><span>starts here.</span></h1>
    </div>
    <div class="auth-right">
      <div class="auth-card">
        <h2 class="auth-title">Create account</h2>
        <p class="auth-subtitle">Get started with ubuHle Admin</p>

        <div v-if="error" class="auth-error"><i class="bi bi-exclamation-circle mr-2"></i>{{ error }}</div>
        <div v-if="success" class="auth-success"><i class="bi bi-check-circle mr-2"></i>{{ success }}</div>

        <form @submit.prevent="submit">
          <div class="auth-row">
            <div class="auth-field">
              <label class="auth-label">First Name</label>
              <input v-model="form.firstName" class="auth-input" required maxlength="100" placeholder="Jane" />
            </div>
            <div class="auth-field">
              <label class="auth-label">Last Name</label>
              <input v-model="form.lastName" class="auth-input" required maxlength="100" placeholder="Doe" />
            </div>
          </div>
          <div class="auth-field">
            <label class="auth-label">Email address</label>
            <input v-model="form.email" type="email" class="auth-input" required placeholder="you@example.com" />
          </div>
          <div class="auth-field">
            <label class="auth-label">Phone Number</label>
            <input v-model="form.phoneNumber" type="tel" class="auth-input" placeholder="+27 ..." required />
          </div>
          <div class="auth-field">
            <label class="auth-label">Password</label>
            <div class="auth-input-wrap">
              <input
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                class="auth-input"
                required
                minlength="6"
                placeholder="Minimum 6 characters"
                autocomplete="new-password"
              />
              <button type="button" class="auth-eye" @click="showPassword = !showPassword">
                <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </button>
            </div>
          </div>
          <button type="submit" class="auth-btn" :disabled="loading">
            <span v-if="loading" class="auth-spinner"></span>
            <span v-else>Create Account</span>
          </button>
        </form>
        <p class="auth-switch">
          Already have an account? <router-link :to="{ name: 'Login' }">Sign in</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterView',
  data () {
    return {
      form: { firstName: '', lastName: '', email: '', phoneNumber: '', password: '' },
      showPassword: false,
      loading: false,
      error: null,
      success: null
    }
  },
  methods: {
    async submit () {
      this.error = null
      this.success = null
      this.loading = true
      try {
        await this.$store.dispatch('auth/register', this.form)
        this.success = 'Account created! An OTP was sent to your phone.'
        setTimeout(() => {
          this.$router.push({ name: 'VerifyAccount', query: { email: this.form.email } })
        }, 2000)
      } catch (err) {
        this.error = err.response?.data?.message || 'Registration failed. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.auth-page { min-height: 100vh; display: flex; }
.auth-left {
  width: 42%;
  background: #212121;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px 48px;
  position: relative;
  overflow: hidden;
}
.auth-left::before {
  content: ''; position: absolute;
  width: 400px; height: 400px;
  background: rgba(255,152,0,0.07);
  border-radius: 50%; bottom: -100px; right: -100px; pointer-events: none;
}
.auth-brand { display: flex; align-items: center; gap: 12px; color: #fff; font-weight: 700; font-size: 1rem; }
.auth-brand-logo { width: 120px; height: 40px; object-fit: contain; flex-shrink: 0; }
.auth-tagline { font-size: 2.6rem; font-weight: 800; color: rgba(255,255,255,0.85); line-height: 1.2; margin-bottom: 60px; }
.auth-tagline span { color: rgb(255,152,0); }
.auth-right { flex: 1; display: flex; align-items: center; justify-content: center; background: #f5f5f5; padding: 40px 20px; overflow-y: auto; }
.auth-card { background: #fff; border-radius: 16px; padding: 36px; width: 100%; max-width: 440px; box-shadow: 0 4px 32px rgba(0,0,0,0.08); }
.auth-title { font-size: 1.6rem; font-weight: 800; color: #212121; margin: 0 0 4px; }
.auth-subtitle { color: #9e9e9e; font-size: 0.9rem; margin-bottom: 24px; }
.auth-error { background: #fce4ec; border-left: 4px solid #ef5350; color: #b71c1c; border-radius: 8px; padding: 10px 14px; font-size: 0.85rem; margin-bottom: 16px; }
.auth-success { background: #e8f5e9; border-left: 4px solid #66bb6a; color: #1b5e20; border-radius: 8px; padding: 10px 14px; font-size: 0.85rem; margin-bottom: 16px; }
.auth-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.auth-field { margin-bottom: 16px; }
.auth-label { display: block; font-size: 0.8rem; font-weight: 600; color: #424242; margin-bottom: 6px; }
.auth-input-wrap { position: relative; }
.auth-input { width: 100%; border: 1.5px solid #e0e0e0; border-radius: 10px; padding: 11px 14px; font-size: 0.9rem; outline: none; transition: border-color 0.15s, box-shadow 0.15s; background: #fafafa; color: #212121; }
.auth-input:focus { border-color: rgb(255,152,0); box-shadow: 0 0 0 3px rgba(255,152,0,0.12); background: #fff; }
.auth-eye { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #9e9e9e; font-size: 1rem; padding: 0; }
.auth-eye:hover { color: #212121; }
.auth-btn { width: 100%; padding: 12px; background: rgb(255,152,0); color: #fff; border: none; border-radius: 10px; font-size: 0.95rem; font-weight: 700; cursor: pointer; transition: background 0.18s, box-shadow 0.18s; display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 4px; }
.auth-btn:hover:not(:disabled) { background: rgb(230,126,0); box-shadow: 0 4px 16px rgba(255,152,0,0.35); }
.auth-btn:disabled { opacity: 0.65; cursor: not-allowed; }
.auth-spinner { width: 18px; height: 18px; border: 2.5px solid rgba(255,255,255,0.3); border-top-color: #fff; border-radius: 50%; animation: spin 0.7s linear infinite; display: inline-block; }
@keyframes spin { to { transform: rotate(360deg); } }
.auth-switch { text-align: center; margin-top: 20px; font-size: 0.85rem; color: #9e9e9e; margin-bottom: 0; }
.auth-switch a { color: rgb(255,152,0); text-decoration: none; font-weight: 600; }
.auth-switch a:hover { text-decoration: underline; }
@media (max-width: 768px) { .auth-left { display: none; } .auth-right { background: #212121; } .auth-card { box-shadow: none; } }
</style>
